import React, { Component } from 'react';
import * as api from '../../api';
import 'semantic-ui-css/semantic.min.css';
import WithoutFilteringQsrCommentaryDatatable from "../../components/table/without-filtering-qsr-commentary-data-table";
import QsrCommentaryTableHeader from '../qsr-commentary/qsr-commentary-table-header'
import QsrCommentaryTableRow from '../qsr-commentary/qsr-commentary-table-row'
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';
export default class QsrCommentaryTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ApiDataProvider(api.getQsrCommentary, [this.props.customerId, this.props.siteKey])
        };

    }

    componentDidMount = () => {
       
        ReactGA.pageview('qsr tab');
    };

    render() {
        return (

            <WithoutFilteringQsrCommentaryDatatable dataProvider={this.state.dataProvider} contextData={{ customerId: this.props.customerId }} defaultSort={"id"} headerComponent={QsrCommentaryTableHeader} rowComponent={QsrCommentaryTableRow} name={"QsrCommentary"} />
        );
    }
}